import React from "react";
import { useGetTrendingQuery } from "./Trendingapislice";
import useTitle from "../hooks/useTitle";
import LoadingIndicator from "../components/BasicComponents/LoadingIndicator";
import { IoStarOutline, IoTrendingUpSharp } from "react-icons/io5";

export default function Trending() {
  useTitle("Vizta Trending");
  const {
    data: trendingData,
    error,
    isLoading,
    isSuccess,
  } = useGetTrendingQuery();
  console.log(trendingData);

  if (isLoading) return <LoadingIndicator />;

  if (error) {
    return (
      <div className="flex items-center justify-center h-full w-full">
        <div className="flex flex-col items-center">
          <IoTrendingUpSharp className="text-9xl" />
          <h1 className="text-2xl font-semibold text-gray-700 mt-4">
            You don’t have any trending.
          </h1>
          <p className="text-gray-500 mt-2">
            Get quick access to items trending with you—no need to trend your
            inbox for a link.
          </p>
        </div>
      </div>
    );
  }

  if (isSuccess) {
    return (
      <div className="flex items-center justify-center h-screen  ml-[5%] ">
        <div className="flex flex-col items-center">
          <IoTrendingUpSharp className="text-9xl" />
          <h1 className="text-2xl font-medium text-gray-700 mt-4">
            Stay updated with the latest tech trends here.
          </h1>

          <p className="text-gray-500 mt-2">
            Get quick access to items trending with you—no need to trend your
            inbox for a link.
          </p>
        </div>
      </div>
    );
  }
}
